import React from 'react';
import Modal from '@aha-app/react-bootstrap-modal';
import Fred from './Fred';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { StartControllerScope, useController } from '@aha-app/mvc';
import { view } from '@aha-app/react-easy-state';
import FredController from './controllers/FredController';

const FredModal = () => {
  const controller = useController(FredController);
  const { open } = controller.state;

  return (
    <Modal
      show={open}
      className='modal-flex fred-modal undraggable'
      onHide={() => controller.actionClose()}
    >
      <ErrorBoundary modal>
        <Fred />
      </ErrorBoundary>
    </Modal>
  );
};

const ControlledFredModal = StartControllerScope(
  FredController,
  view(FredModal)
);

export default ControlledFredModal;
